import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiDialog-paper": {
      background: "rgb(100 100 100 / 51%)",
      WebkitBackdropFilter: "saturate(180%) blur(20px)",
      backdropFilter: "saturate(180%) blur(20px)",
      borderRadius: "1rem",
      color: "#ccc",
    },
  },
}));

const DialogBox = (props) => {
  const classes = useStyles();

  const { open, content, title, save } = props;

  const handleClose = () => {
    props.handleClose();
  };

  return (
    <div>
      <Dialog
        className={classes.root}
        open={open}
        fullWidth
        maxWidth={"sm"}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>{content}</DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={save} color="primary" autoFocus>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default DialogBox;
